<template lang="pug">
div
	.card
		.card-header.bg-dark.text-white
			span.fa.fa-file.mr-2
			| Contrato
		.card-body.bg-light
			h2
				span.fa.fa-quote-right.mr-4
				| {{contrato.Titulo}}
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-md-6
					.card
						.card-header.bg-light
							b
								span.fa.fa-file.mr-2
								| Contrato nº {{contrato.ContratoOriginal}} / {{contrato.ContratoID}}
						.card-body(style="line-height:20px;")
							h4 <b>{{contrato.EmpresaNombre}}</b>
							div.mt-3 CIF: <b>{{contrato.EmpresaCIF}}</b>
							div Teléfono: <b>{{contrato.EmpresaTelefono}}</b>
							div Fax: <b>{{contrato.EmpresaFax}}</b>
							div Email: <b>{{contrato.EmpresaEmail}}</b>
							div Dirección: <b>{{contrato.EmpresaDireccion}}</b>

				.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-md-6
					.card
						.card-header.bg-info.text-white
							.row
								.col.text-left
									b
										span.fa.fa-building.mr-2
										| Cliente
								.col.text-right
									button.btn.btn-sm.btn-dark(@click="verEditor = true", v-if="permisoEditarCliente")
										span.fa.fa-edit.mr-2
										| Editar datos del cliente
						.card-body(style="line-height:20px;")
							h4 <b>{{contrato.cliente.NombreCliente}}</b>
							div.mt-3 CIF: <b>{{contrato.cliente.CIF}}</b>
							div Representante: <b>{{contrato.cliente.Representante}}</b>
							div Teléfono: <b>{{contrato.cliente.Telefono}}</b>
							div Email: <b>{{contrato.cliente.Email}}</b>
							div Dirección: <b>{{contrato.cliente.Direccion}}</b>
		.card-body.bg-light
			div(style="display:flex;flex-direction:row;justify-content:space-between;")
				div.p-3
					b Fecha de inicio
					br
					| {{contrato.FechaInicio | moment('DD-MM-YYYY')}}
				div.p-3
					b Fecha de finalización
					br
					| {{contrato.FechaFin | moment('DD-MM-YYYY')}}
				div.p-3
					b Tipo de contrato
					br
					| {{contrato.TipoNombre}}
				div.p-3
					b Evento
					br
					| {{contrato.EventoNombre || 'Ninguno'}}
				div.p-3
					b Partida
					br
					| {{contrato.PartidaNombre || 'Ninguno'}}
				div.p-3
					b Intermediario
					br
					| {{contrato.IntermediarioNombre || 'Ninguno'}}
	div.mt-4.mb-2
		h3 Servicios contratados
	.card
		table.table.table-striped.m-0
			thead.bg-dark.text-white
				tr
					th Concepto
					th Importe unitario
					th Cantidad
					th Bruto
					th Descuento
					th Impuestos
					th Neto
					th Total
			tbody
				tr(v-for="linea in contrato.lineas")
					td
						span.mr-2(v-if="!linea.ArticuloID") {{linea.CatalogoNombre}} -
						span {{linea.Concepto}}
						div(v-if="linea.Unidades > 1", style="display:block;position:relative;")
							i {{linea.Unidades}} unidades

					td {{linea.ImporteUnitario | currency}}
					td {{linea.Cantidad}}
					td {{linea.ImporteBruto | currency}}
					td {{linea.Descuento | currency('%')}}
					td
						span(v-if="linea.Impuestos")
							| {{linea.ImpuestosNombre - linea.Impuestos | currency('%')}}
						span(v-else) -
					td {{linea.ImporteNeto | currency}}
					td {{linea.ImporteTotal | currency}}
	div.mt-2.mb-4.text-right(style="text-align:right;")
		div.text-left.mr-3(style="position:relative;display:inline-block;max-width:400px;vertical-align:top;")
			table.table.table-striped(style="min-width:200px;max-width:400px;border:1px solid #e0e0e0;")
				thead
					tr.bg-dark.text-white
						th
							span.fa.fa-comments.mr-2
							b Comentarios
				tbody
					tr
						td
							| {{contrato.Comentarios}}
		div.text-left.mr-3(style="position:relative;display:inline-block;max-width:400px;vertical-align:top;")
			table.table.table-striped(style="min-width:200px;max-width:400px;border:1px solid #e0e0e0;")
				thead
					tr.bg-warning.text-dark
						th
							span.fa.fa-money.mr-2
							b Forma de pago
				tbody
					tr
						td
							| {{contrato.FormaDePago}}
					tr(v-if="contrato.cliente.IBAN")
						td
							b IBAN:
							|  {{contrato.cliente.IBAN}}
		div.text-left(style="position:relative;display:inline-block;max-width:400px;vertical-align:top;")
			table.table.table-striped(style="max-width:400px;border:1px solid #e0e0e0;")
				thead
					tr.bg-danger.text-white
						th(colspan="2")
							span.fa.fa-calculator.mr-2
							b Totales
				tbody
					tr.text-right
						td Bruto
						td {{contrato.ImporteBruto | currency}}
					tr.text-right(v-if="contrato.DescuentoCadenaValor")
						td Dto cad. valor
						td {{contrato.DescuentoCadenaValor | currency('%')}}
					tr.text-right(v-if="contrato.DescuentoComercial")
						td Descuento comercial
						td {{contrato.DescuentoComercial | currency('%')}}
					tr.text-right
						td Neto
						td {{contrato.ImporteNeto | currency}}
					tr.text-right
					tr.text-right
						td Impuestos
						td {{contrato.ImporteTotal - contrato.ImporteNeto | currency}}
					tr.bg-warning.text-right(style="font-size:1.3em;")
						td
							b TOTAL
						td
							b {{contrato.ImporteTotal | currency}}
	div.mt-4.mb-2
		h3 Facturación y pagos
	.row.mt-2
		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
			.card
				.card-header.bg-info.text-white
					| Plan de facturación
				table.table-striped.table.m-0
					thead
						tr
							th Fecha de emisión
							th Importe neto
							th Importe con impuestos
							th
					tbody
						tr(v-for="(fac, i) in contrato.facturacion", :key="i")
							td {{fac.FechaFactura | moment('DD-MM-YYYY')}}
							td {{fac.ImporteNeto | currency}}
							td {{fac.ImporteTotal | currency}}
							td
								span.fa.fa-check(v-if="fac.ReciboPagadaID")

		.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
			.card
				.card-header.bg-danger.text-white
					| Plan de pagos
				table.table-striped.table.m-0
					thead
						tr
							th Fecha de vencimiento
							th Importe
							th Estado
					tbody
						tr(v-for="(rec, i) in contrato.recibos", :key="i")
							td {{rec.FechaVencimiento | moment('DD-MM-YYYY')}}
							td {{rec.ImporteTotal | currency}}
							td
								span.badge.badge-succes.p-2(v-if="rec.Estado === 'Pagado'") Pagado
								span.badge.badge-warning.p-2(v-else) Pendiente
	EditorCliente(:contrato="contrato", @actualizar="contrato.cliente = $event", @cerrar="verEditor=false", v-if="verEditor")
</template>

<script>
import { mapGetters } from 'vuex'
import EditorCliente from './editor-datos-cliente'
export default {
	props: ['contrato'],
	components: {
		EditorCliente
	},
	data () {
		return {
			imprimir: null,
			editaCliente: null,
			verEditor: false
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		}),
		permisoEditarCliente () {
			if (this.contrato.Estado !== 'Borrador') {
				return false
			}
			if (this.contrato.AgenteID !== this.usuario.ID && !this.permisos.contratos_crearAjenos) {
				return false
			}

			return true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/visor-contrato/detalles-contrato.vue